import { t } from 'ttag'
import { useContext } from 'react'

import MediaKit from '@main/containers/educators/MediaKit'
import mediaKitSvg from '@h2/assets/svg/blockGraphics/mediaKit.svg'
import { Globals } from '@h2/globals'

import { Promotion } from '../../promotion'

const MediaKitBox = () => {
  const heading = t`Media Kit`
  const { systemName } = useContext(Globals)

  return (
    <Promotion color="orange" variant="navigator" modalBody={<MediaKit />}>
      <Promotion.Heading>{heading}</Promotion.Heading>
      <Promotion.Text>{t`To help promote the ${systemName}, we offer the materials which you can print and share.`}</Promotion.Text>
      <Promotion.Button>{t`Start promoting`}</Promotion.Button>
      <Promotion.Image src={mediaKitSvg} />
    </Promotion>
  )
}

export { MediaKitBox }
